module.exports = __webpack_public_path__ + "img/kate_macK211238.afae64ac.jpg";